import type { QueryKey } from '@tanstack/react-query';

function getQueryKeys(type: string[]) {
  return {
    all: type as QueryKey,
    lists(): QueryKey {
      return [...this.all, 'list'] as const;
    },
    list(filters: Record<string, unknown>): QueryKey {
      return [...this.lists(), filters] as const;
    },
    details(): QueryKey {
      return [...this.all, 'detail'] as const;
    },
    detail(id: number | string): QueryKey {
      return [...this.details(), id] as const;
    },
  };
}

export { getQueryKeys };
